export { ColorInput } from './color-input';
export type { ColorInputProps, ColorInputStylesNames } from './color-input';
